import React from "react";

const Checkbox = ({ checked, onChange, disabled }) => {
  return (
    <label className="relative flex items-center cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only peer"
        disabled={disabled}
      />
      <div
        className={`w-[18px] h-[18px] border-2 ${
          checked ? "border-primary" : "border-secondary/40"
        }  rounded-[5px] bg-background peer-checked:bg-primary flex items-center justify-center transition-all duration-200 ${
          disabled
            ? `cursor-not-allowed ${
                checked
                  ? "!border-primary/20 peer-checked:bg-primary/60"
                  : "!border-secondary/20"
              }`
            : "cursor-pointer"
        }`}
      >
        {checked && (
          <svg
            className="w-3 h-3 text-secondary/70"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </div>
    </label>
  );
};

export default Checkbox;
